var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.typeOfUser === 'Free')?_c('v-card',[_c('v-card-text',[_c('br'),_c('br'),_c('br'),_c('div',{staticClass:"text-h5 text-center font-weight-bold",attrs:{"align-center":""}},[_vm._v(" This feature is available on paid version ")]),_c('br'),_c('br')])],1):_c('BotFlow',{attrs:{"botid":_vm.botid}})
}
var staticRenderFns = []

export { render, staticRenderFns }